/*
* Render functions
*/
import { cSpace, hSpace } from '@/utils/css-utils'

export const rT = (tag) => `<span class="tag">${tag}</span>`
export const rC = (className) => `<span class="atn">${className}</span>`
export const rO = (operator) => `<span class="pun">${operator}</span>`
export const rV = (variable) => `<span class="atv">${variable}</span>`

export const getButtonsClass = (className) => {
  switch (className) {
    case 'flat':
      return 'flat-icons'
    case 'material':
      return 'material-icons'
    case 'fontawesome':
      return 'fontawesome-icons'
  }
}

export const enableSpinButton = (list, key) => {
  return list.includes(key)
}

export const rButton = (style, button) => {
  switch (style) {
    case 'flat':
      return rFlatButton(button)
    case 'material':
      return rMaterialButton(button)
    case 'fontawesome':
      return rFontAwesomeButton(button)
  }
}

export const cButton = (style, button) => {
  switch (style) {
    case 'flat':
      return cFlatButton(button)
    case 'material':
      return cMaterialButton(button)
    case 'fontawesome':
      return cFontAwesomeButton(button)
  }
}

const cMaterialButton = (button) => {
  if (button === 'play') {
    return `<div id="buttonPlay" class="material-icons-outlined" style="display: none;">${materialButtonName(button)}</div>`
  }
  if (button === 'pause') {
    return `<div id="buttonPause" class="material-icons-outlined" style="display: inline;">${materialButtonName(button)}</div>`
  }
  return `<div id="${cUniqueID(button)}" class="material-icons-outlined">${materialButtonName(button)}</div>`
}

const rMaterialButton = (button) => {

  if (button === 'play') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPlay"')} ${rC('class')}${rO('=')}` +
      `${rV('"material-icons-outlined"')} ${rC('style')}${rO('=')}` +
      `${rV('"display: none;"')}&gt;` +
      `${materialButtonName(button)}` +
      `${rT('&lt;/div&gt;')}`
  }

  if (button === 'pause') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPause"')} ${rC('class')}${rO('=')}` +
      `${rV('"material-icons-outlined"')} ${rC('style')}${rO('=')}` +
      `${rV('"display: inline;"')}&gt;` +
      `${materialButtonName(button)}` +
      `${rT('&lt;/div&gt;')}`
  }

  return `${rT('&lt;div')} ${rUniqueID(button)} ${rC('class')}${rO('=')}${rV('"material-icons-outlined"')}&gt;` +
    `${materialButtonName(button)}` +
    `${rT('&lt;/div&gt;')}`
}

const materialButtonName = (name) => {
  switch (name) {
    case 'left':
      return 'navigate_before'
    case 'play':
      return 'play_arrow'
    case 'pause':
      return 'pause'
    case 'right':
      return 'navigate_next'
    case 'up':
      return 'keyboard_arrow_up'
    case 'down':
      return 'keyboard_arrow_down'
    case 'zoomin':
      return 'add'
    case 'zoomout':
      return 'remove'
    case 'fullscreen':
      return 'fullscreen'
    case 'info':
      return 'info'
    default:
      return ''
  }
}

const switchID = (button) => {
  switch (button) {
    case 'left':
      return 'buttonLeft'
    case 'play':
      return 'buttonPlay'
    case 'pause':
      return 'buttonPause'
    case 'right':
      return 'buttonRight'
    case 'up':
      return 'buttonUp'
    case 'down':
      return 'buttonDown'
    case 'zoomin':
      return 'buttonZoomIn'
    case 'zoomout':
      return 'buttonZoomOut'
    case 'fullscreen':
      return 'buttonFullScreen'
    case 'info':
      return 'buttonInfo'
    default:
      return ''
  }
}

const rUniqueID = (button) => {
  const buttonID = `"${switchID(button)}"`
  return `${rC('id')}${rO('=')}${rV(buttonID)}`
}

const cUniqueID = (button) => switchID(button)

const rFlatButton = (button) => {
  const buttonClass = `"button ${flatButtonName(button)}"`

  if (button === 'play') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPlay"')} ${rC('class')}${rO('=')}${rV(buttonClass)} ` +
      `${rC('style')}${rO('=')}${rV('"display: none;"')}&gt;` +
      `${rT('&lt;/div&gt;')}`
  }

  if (button === 'pause') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPause"')} ${rC('class')}${rO('=')}${rV(buttonClass)} ` +
      `${rC('style')}${rO('=')}${rV('"display: inline;"')}&gt;` +
      `${rT('&lt;/div&gt;')}`
  }

  return `${rT('&lt;div')} ${rUniqueID(button)} ${rC('class')}${rO('=')}${rV(buttonClass)}&gt;` +
    `${rT('&lt;/div&gt;')}`
}

const flatButtonName = (name) => {
  switch (name) {
    case 'left':
      return 'flaticon-keyboard54'
    case 'play':
      return 'flaticon-play106'
    case 'pause':
      return 'flaticon-pause44'
    case 'right':
      return 'flaticon-keyboard53'
    case 'up':
      return 'flaticon-expand39'
    case 'down':
      return 'flaticon-expand38'
    case 'zoomin':
      return 'flaticon-round57'
    case 'zoomout':
      return 'flaticon-round56'
    case 'fullscreen':
      return 'flaticon-move26'
    case 'info':
      return 'flaticon-round52'
    default:
      return ''
  }
}

const cFlatButton = (button) => {
  const buttonClass = `button ${flatButtonName(button)}`
  if (button === 'play') {
    return `<div id="buttonPlay" class="${buttonClass}" style="display: none;"></div>`
  }
  if (button === 'pause') {
    return `<div id="buttonPause" class="${buttonClass}" style="display: inline;"></div>`
  }
  return `<div id="${cUniqueID(button)}" class="${buttonClass}"></div>`
}

const rFontAwesomeButton = (button) => {
  const buttonClass = `"fa ${fontawesomeButtonName(button)}"`

  if (button === 'play') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPlay"')} ${rC('class')}${rO('=')}${rV(buttonClass)} `+
      `${rC('style')}${rO('=')}${rV('"display: none;"')}&gt;` +
      `${rT('&lt;/div&gt;')}`
  }

  if (button === 'pause') {
    return `${rT('&lt;div')} ${rC('id')}${rO('=')}${rV('"buttonPause"')} ${rC('class')}${rO('=')}${rV(buttonClass)} ` +
      `${rC('style')}${rO('=')}${rV('"display: inline;"')}&gt;` +
      `${rT('&lt;/div&gt;')}`
  }

  return `${rT('&lt;div')} ${rUniqueID(button)} ${rC('class')}${rO('=')}${rV(buttonClass)}&gt;` +
    `${rT('&lt;/div&gt;')}`
}

const cFontAwesomeButton = (button) => {
  const buttonClass = `fa ${fontawesomeButtonName(button)}`
  if (button === 'play') {
    return `<div id="buttonPlay" class="${buttonClass}" style="display: none;"></div>`
  }
  if (button === 'pause') {
    return `<div id="buttonPause" class="${buttonClass}" style="display: inline;"></div>`
  }
  return `<div id="${cUniqueID(button)}" class="${buttonClass}"></div>`
}

const fontawesomeButtonName = (name) => {
  switch (name) {
    case 'left':
      return 'fa-chevron-circle-left'
    case 'play':
      return 'fa-play-circle'
    case 'pause':
      return 'fa-pause-circle'
    case 'right':
      return 'fa-chevron-circle-right'
    case 'up':
      return 'fa-chevron-circle-up'
    case 'down':
      return 'fa-chevron-circle-down'
    case 'zoomin':
      return 'fa-plus-circle'
    case 'zoomout':
      return 'fa-minus-circle'
    case 'fullscreen':
      return 'fa-arrows-alt'
    case 'info':
      return 'fa-info-circle'
    default:
      return ''
  }
}

export const codeSpinButtonsScript = (selectedButtons) => {
  const enableButtonLeft = selectedButtons.includes('left')
  const enableButtonRight = selectedButtons.includes('right')
  const enableButtonUp = selectedButtons.includes('up')
  const enableButtonDown = selectedButtons.includes('down')
  const enableButtonZoomIn = selectedButtons.includes('zoomin')
  const enableButtonZoomOut = selectedButtons.includes('zoomout')
  const enableButtonFullScreen = selectedButtons.includes('fullscreen')
  const enableButtonInfo = selectedButtons.includes('info')

  let defineButtonPlay = codeVariableExpression('buttonPlay')
  let defineButtonPause = codeVariableExpression('buttonPause')
  let defineButtonLeft = enableButtonLeft ? codeVariableExpression('buttonLeft') : ''
  let defineButtonRight = enableButtonRight ? codeVariableExpression('buttonRight') : ''
  let defineButtonUp = enableButtonUp ? codeVariableExpression('buttonUp') : ''
  let defineButtonDown = enableButtonDown ? codeVariableExpression('buttonDown') : ''
  let defineButtonZoomIn = enableButtonZoomIn ? codeVariableExpression('buttonZoomIn') : ''
  let defineButtonZoomOut = enableButtonZoomOut ? codeVariableExpression('buttonZoomOut') : ''
  let defineButtonFullScreen = enableButtonFullScreen ? codeVariableExpression('buttonFullScreen') : ''
  let defineButtonInfo = enableButtonInfo ? codeVariableExpression('buttonInfo') : ''
  let defineIsPlay = `\n${cSpace(2)}let isPlay = true`

  const generatedCodeLeftListener = enableButtonLeft ? codeLeftListener() : ''
  const generatedCodeRightListener = enableButtonRight ? codeRightListener() : ''
  const generatedCodeUpListener = enableButtonUp ? codeUpListener() : ''
  const generatedCodeDownListener = enableButtonDown ? codeDownListener() : ''
  const generatedCodeZoomInListener = enableButtonZoomIn ? codeZoomInListener() : ''
  const generatedCodeZoomOutListener = enableButtonZoomOut ? codeZoomOutListener() : ''
  const generatedCodeFullScreenListener = enableButtonFullScreen ? codeFullScreenListener() : ''
  const generatedCodeInfoListener = enableButtonInfo ? codeInfoListener() : ''

  return `<script>` +
    `\n${cSpace(2)}const spinIndex = 0` +
    defineButtonPlay +
    defineButtonPause +
    defineButtonLeft +
    defineButtonRight +
    defineButtonUp +
    defineButtonDown +
    defineButtonZoomIn +
    defineButtonZoomOut +
    defineButtonFullScreen +
    defineButtonInfo +
    defineIsPlay +
    codeCanPlayFunction() +
    codePlayOrPauseFunction() +
    codePlayListener() +
    codePauseListener() +
    generatedCodeLeftListener +
    generatedCodeRightListener +
    generatedCodeUpListener +
    generatedCodeDownListener +
    generatedCodeZoomInListener +
    generatedCodeZoomOutListener +
    generatedCodeFullScreenListener +
    generatedCodeInfoListener +
    `\n</script>`
}

export const renderSpinButtonsScriptHTML = (selectedButtons) => {
  const enableButtonLeft = selectedButtons.includes('left')
  const enableButtonRight = selectedButtons.includes('right')
  const enableButtonUp = selectedButtons.includes('up')
  const enableButtonDown = selectedButtons.includes('down')
  const enableButtonZoomIn = selectedButtons.includes('zoomin')
  const enableButtonZoomOut = selectedButtons.includes('zoomout')
  const enableButtonFullScreen = selectedButtons.includes('fullscreen')
  const enableButtonInfo = selectedButtons.includes('info')

  let defineButtonPlay = generateVariableExpression('buttonPlay')
  let defineButtonPause = generateVariableExpression('buttonPause')
  let defineButtonLeft = enableButtonLeft ? generateVariableExpression('buttonLeft') : ''
  let defineButtonRight = enableButtonRight ? generateVariableExpression('buttonRight') : ''
  let defineButtonUp = enableButtonUp ? generateVariableExpression('buttonUp') : ''
  let defineButtonDown = enableButtonDown ? generateVariableExpression('buttonDown') : ''
  let defineButtonZoomIn = enableButtonZoomIn ? generateVariableExpression('buttonZoomIn') : ''
  let defineButtonZoomOut = enableButtonZoomOut ? generateVariableExpression('buttonZoomOut') : ''
  let defineButtonFullScreen = enableButtonFullScreen ? generateVariableExpression('buttonFullScreen') : ''
  let defineButtonInfo = enableButtonInfo ? generateVariableExpression('buttonInfo') : ''
  let defineIsPlay = `\n${hSpace(2)}${rT('let')}${hSpace(1)}${rC('isPlay')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('true')}`

  const generatedLeftListener = enableButtonLeft ? generateLeftListener() : ''
  const generatedRightListener = enableButtonRight ? generateRightListener() : ''
  const generatedUpListener = enableButtonUp ? generateUpListener() : ''
  const generatedDownListener = enableButtonDown ? generateDownListener() : ''
  const generatedZoomInListener = enableButtonZoomIn ? generateZoomInListener() : ''
  const generatedZoomOutListener = enableButtonZoomOut ? generateZoomOutListener() : ''
  const generatedFullScreenListener = enableButtonFullScreen ? generateFullScreenListener() : ''
  const generatedInfoListener = enableButtonInfo ? generateInfoListener() : ''

  return `<span class="script"><span class="tag">&lt;script</span><span class="tag">&gt;</span>` +
    `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC('spinIndex')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV(0)}` +
    defineButtonPlay +
    defineButtonPause +
    defineButtonLeft +
    defineButtonRight +
    defineButtonUp +
    defineButtonDown +
    defineButtonZoomIn +
    defineButtonZoomOut +
    defineButtonFullScreen +
    defineButtonInfo +
    defineIsPlay +
    generateCanPlayFunction() +
    generatePlayOrPauseFunction() +
    generatePlayListener() +
    generatePauseListener() +
    generatedLeftListener +
    generatedRightListener +
    generatedUpListener +
    generatedDownListener +
    generatedZoomInListener +
    generatedZoomOutListener +
    generatedFullScreenListener +
    generatedInfoListener +
    `\n<span class="tag">&lt;/script&gt;</span></span>`
}

const generateVariableExpression = (buttonName) => {
  const domExpression = `document.getElementById('${buttonName}')`
  if (buttonName === 'buttonInfo') {
    const domExtraExpression = `document.getElementById('info')`
    return `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC(buttonName)}${hSpace(1)}${rO('=')}${hSpace(1)}${rV(domExpression)}` +
      `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC('infoFrame')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV(domExtraExpression)}`
  }

  return `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC(buttonName)}${hSpace(1)}${rO('=')}${hSpace(1)}${rV(domExpression)}`
}

const codeVariableExpression = (buttonName) => {
  const domExpression = `document.getElementById('${buttonName}')`
  if (buttonName === 'buttonInfo') {
    const domExtraExpression = `document.getElementById('info')`
    return `\n${cSpace(2)}const ${buttonName} = ${domExpression}` +
      `\n${cSpace(2)}const infoFrame = ${domExtraExpression}`
  }

  return `\n${cSpace(2)}const ${buttonName} = ${domExpression}`
}

const generateCanPlayFunction = () => {
  return `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC('canPlay')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('() => {')}` +
    `\n${hSpace(4)}${rT('if')}${hSpace(1)}${rT('(')}${rC('isPlay')}${hSpace(1)}${rO('===')}${hSpace(1)}${rV('false')}${rT(')')}${hSpace(1)}${rV('{')}${hSpace(1)}${rC('return')}${hSpace(1)}${rV('}')}` +
    `\n${hSpace(4)}${rT('buttonPause.click()')}` +
    `\n${hSpace(2)}${rV('}')}`
}

const codeCanPlayFunction = () => {
  return `\n${cSpace(2)}const${cSpace(1)}canPlay${cSpace(1)}=${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}if${cSpace(1)}(isPlay${cSpace(1)}===${cSpace(1)}false)${cSpace(1)}{${cSpace(1)}return${cSpace(1)}}` +
    `\n${cSpace(4)}buttonPause.click()` +
    `\n${cSpace(2)}}`
}

const generatePlayOrPauseFunction = () => {
  return `\n${hSpace(2)}${rT('const')}${hSpace(1)}${rC('playOrPause')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('() => {')}` +
    `\n${hSpace(4)}${rT('if')}${hSpace(1)}${rT('(')}${rC('isPlay')}${rT(')')}${hSpace(1)}${rV('{')}` +
    `\n${hSpace(6)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.pause()')}` +
    `\n${hSpace(6)}${rT('buttonPause.style.display')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('\'none\'')}` +
    `\n${hSpace(6)}${rT('buttonPlay.style.display')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('\'inline\'')}` +
    `\n${hSpace(6)}${rT('isPlay')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('false')}` +
    `\n${hSpace(4)}${rV('}')}${hSpace(1)}${rT('else')}${hSpace(1)}${rT('{')}` +
    `\n${hSpace(6)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.play()')}` +
    `\n${hSpace(6)}${rT('buttonPause.style.display')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('\'inline\'')}` +
    `\n${hSpace(6)}${rT('buttonPlay.style.display')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('\'none\'')}` +
    `\n${hSpace(6)}${rT('isPlay')}${hSpace(1)}${rO('=')}${hSpace(1)}${rV('true')}` +
    `\n${hSpace(4)}${rV('}')}` +
    `\n${hSpace(2)}${rV('}')}`
}

const codePlayOrPauseFunction = () => {
  return `\n${cSpace(2)}const${cSpace(1)}playOrPause${cSpace(1)}=${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}if${cSpace(1)}(isPlay)${cSpace(1)}{` +
    `\n${cSpace(6)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.pause()` +
    `\n${cSpace(6)}buttonPause.style.display${cSpace(1)}=${cSpace(1)}\'none\'` +
    `\n${cSpace(6)}buttonPlay.style.display${cSpace(1)}=${cSpace(1)}\'inline\'` +
    `\n${cSpace(6)}isPlay${cSpace(1)}=${cSpace(1)}false` +
    `\n${cSpace(4)}}${cSpace(1)}else${cSpace(1)}{` +
    `\n${cSpace(6)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.play()` +
    `\n${cSpace(6)}buttonPause.style.display${cSpace(1)}=${cSpace(1)}\'inline\'` +
    `\n${cSpace(6)}buttonPlay.style.display${cSpace(1)}=${cSpace(1)}\'none\'` +
    `\n${cSpace(6)}isPlay${cSpace(1)}=${cSpace(1)}'true'` +
    `\n${cSpace(4)}}` +
    `\n${cSpace(2)}}`
}

const generatePlayListener = () => {
  return `\n${hSpace(2)}${rT('buttonPlay.addEventListener(\'click\', playOrPause)')}`
}

const codePlayListener = () => {
  return `\n${cSpace(2)}buttonPlay.addEventListener(\'click\', playOrPause)`
}

const generatePauseListener = () => {
  return `\n${hSpace(2)}${rT('buttonPause.addEventListener(\'click\', playOrPause)')}`
}

const codePauseListener = () => {
  return `\n${cSpace(2)}buttonPause.addEventListener(\'click\', playOrPause)`
}

const generateLeftListener = () => {
  return `\n${hSpace(2)}${rT('buttonLeft.addEventListener(\'click\', () => {')}` +
  `\n${hSpace(4)}${rT('canPlay()')}` +
  `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateX(-1)')}` +
  `\n${hSpace(2)}${rT('})')}`
}

const codeLeftListener = () => {
  return `\n${cSpace(2)}buttonLeft.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateX(-1)` +
    `\n${cSpace(2)}})`
}

const generateRightListener = () => {
  return `\n${hSpace(2)}${rT('buttonRight.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateX(1)')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeRightListener = () => {
  return `\n${cSpace(2)}buttonRight.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateX(1)` +
    `\n${cSpace(2)}})`
}

const generateUpListener = () => {
  return `\n${hSpace(2)}${rT('buttonUp.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateY(-1)')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeUpListener = () => {
  return `\n${cSpace(2)}buttonUp.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateY(-1)` +
    `\n${cSpace(2)}})`
}

const generateDownListener = () => {
  return `\n${hSpace(2)}${rT('buttonDown.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateY(1)')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeDownListener = () => {
  return `\n${cSpace(2)}buttonDown.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.rotateY(1)` +
    `\n${cSpace(2)}})`
}

const generateZoomInListener = () => {
  return `\n${hSpace(2)}${rT('buttonZoomIn.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.zoomIn()')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeZoomInListener = () => {
  return `\n${cSpace(2)}buttonZoomIn.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.zoomIn()` +
    `\n${cSpace(2)}})`
}

const generateZoomOutListener = () => {
  return `\n${hSpace(2)}${rT('buttonZoomOut.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').child(spinIndex).spin.zoomOut()')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeZoomOutListener = () => {
  return `\n${cSpace(2)}buttonZoomOut.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.zoomOut()` +
    `\n${cSpace(2)}})`
}

const generateFullScreenListener = () => {
  return `\n${hSpace(2)}${rT('buttonFullScreen.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('canPlay()')}` +
    `\n${hSpace(4)}${rT('Sirv.getInstance(\'#smv\').fullscreen()')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeFullScreenListener = () => {
  return `\n${cSpace(2)}buttonFullScreen.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}canPlay()` +
    `\n${cSpace(4)}Sirv.getInstance(\'#smv\').fullscreen()` +
    `\n${cSpace(2)}})`
}

const generateInfoListener = () => {
  return `\n${hSpace(2)}${rT('buttonInfo.addEventListener(\'click\', () => {')}` +
    `\n${hSpace(4)}${rT('const frame = Sirv.getInstance(\'#smv\').child(spinIndex).spin.currentFrame()')}` +
    `\n${hSpace(4)}${rT('const content = `Row: ${frame.row}, Col: ${frame.column}`')}` +
    `\n${hSpace(4)}${rT('infoFrame.textContent = content')}` +
    `\n${hSpace(4)}${rT('infoFrame.style.display = \'flex\'')}` +
    `\n${hSpace(4)}${rT('setTimeout(() => {')}` +
    `\n${hSpace(6)}${rT('infoFrame.style.display = \'none\'')}` +
    `\n${hSpace(4)}${rT('}, 2000)')}` +
    `\n${hSpace(2)}${rT('})')}`
}

const codeInfoListener = () => {
  return `\n${cSpace(2)}buttonInfo.addEventListener(\'click\',${cSpace(1)}()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(4)}const${cSpace(1)}frame${cSpace(1)}=${cSpace(1)}Sirv.getInstance(\'#smv\').child(spinIndex).spin.currentFrame()` +
    `\n${cSpace(4)}const${cSpace(1)}content${cSpace(1)}=${cSpace(1)}\`Row:${cSpace(1)}\$\{frame.row\},${cSpace(1)}Col:${cSpace(1)}\$\{frame.column\}\`` +
    `\n${cSpace(4)}infoFrame.textContent${cSpace(1)}=${cSpace(1)}content` +
    `\n${cSpace(4)}infoFrame.style.display${cSpace(1)}=${cSpace(1)}\'flex\'` +
    `\n${cSpace(4)}setTimeout(()${cSpace(1)}=>${cSpace(1)}{` +
    `\n${cSpace(6)}infoFrame.style.display${cSpace(1)}=${cSpace(1)}\'none\'` +
    `\n${cSpace(4)}},${cSpace(1)}2000)` +
    `\n${cSpace(2)}})`
}

